export const APP_NAME = 'Asset Management System';
export const APP_MAIN_PAGE = 'main_menu';

export const DATE_FORMAT_YYYY_MM_DD = 'yyyy/MM/DD';
export const DATE_HYPHEN_FORMAT = 'YYYY-MM-DD';

export const MODAL_TYPES = {
  ALERT_MODAL: 'ALERT_MODAL',
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  UPLOAD_IMAGE_MODAL: 'UPLOAD_IMAGE_MODAL',
};

// not insert 400 into this list
// error code 400 is handled by your feature
export const ERROR_NOTIFICATION_CODES = [403, 404, 500, 503];

export const SELECT_ORGANIZATION_TREE_TYPE_STORE: number = 1;
export const SELECT_ORGANIZATION_TREE_TYPE_NOT_STORE: number = 2;

export const STATUS_SUCCESS: string = 'success';
export const STATUS_ERROR: string = 'error';
export const INVENTORY_STATUS_POSSIBLE: number = 1;
export const INVENTORY_STATUS_FAULT: number = 2;
export const INVENTORY_STATUS_LOSS: number = 4;

export const APPROVAL_STATUS_APPROVED_COMPLETED_REPORT_COMPLETED: number = 1;
export const APPROVAL_STATUS_APPROVED_COMPLETED_NEED_REPORT: number = 2;
export const APPROVAL_STATUS_APPROVED_COMPLETED: number = 3;
export const APPROVAL_STATUS_SENT: number = 4;
export const APPROVAL_STATUS_SEND_BACK: number = 5;
export const APPROVAL_STATUS_UNSENT: number = 6;

export const RESTAURANT_DEPARTMENT_CLASSIFICATION: string = 'T';
export const UNIT_DEPARTMENT_CLASSIFICATION: string = 'U';
export const BLOCK_DEPARTMENT_CLASSIFICATION: string = 'B';
export const AREA_DEPARTMENT_CLASSIFICATION: string = 'A';

export const PERMISSIONS = {};

// エリアマネージャー（安楽亭） Area Manager (Anrakutei), エリア長（アークミール）Area leader (Arcmeal)
export const AREA_MANAGEMENT_LEVEL = '300';
// エリア長（アークミール）Area leader (Arcmeal), ブロック長（安楽亭）Block leader (Anrakutei)
export const BLOCK_MANAGEMENT_LEVEL = '200';

// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
export const PRIMARY_BUTTON = 0;

export const PLUS_TEXT = '＋';
export const MINUS_TEXT = 'ー';

// MENU TYPE
export const MENU_TYPE = {
  DEFAULT: 0,
  MAIN_MENU: 1,
  SUB_MENU: 2,
  SUB_TITLE_MENU: 3,
};

export const MENU_TYPE_NAME = {
  MAIN_MENU: '通常',
  SUB_MENU: 'サブ',
};

// image size setting
export const IMAGE_SIZES = {
  menu_book_mobile_introduce_img: {
    minWidth: 1022,
    minHeight: 504,
    maxWidth: 1250,
    maxHeight: 616,
    maxFileSize: 1, //MB
  },
  menu_book_tablet_introduce_img: {
    minWidth: 1022,
    minHeight: 504,
    maxWidth: 1250,
    maxHeight: 616,
    maxFileSize: 1, //MB
  },
  menu_book_tablet_background_img: {
    minWidth: 154,
    minHeight: 81,
    maxWidth: 190,
    maxHeight: 99,
    maxFileSize: 1, //MB
  },
  course_mobile_introduce_img: {
    minWidth: 1022,
    minHeight: 504,
    maxWidth: 1250,
    maxHeight: 616,
    maxFileSize: 1, //MB
  },
  course_tablet_introduce_img: {
    minWidth: 1022,
    minHeight: 504,
    maxWidth: 1250,
    maxHeight: 616,
    maxFileSize: 1, //MB
  },
  course_tablet_background_img: {
    minWidth: 154,
    minHeight: 81,
    maxWidth: 190,
    maxHeight: 99,
    maxFileSize: 1, //MB
  },
  genre_order_background_img: {
    minWidth: 432,
    minHeight: 366,
    maxWidth: 528,
    maxHeight: 448,
    maxFileSize: 1, //MB
  },
  genre_tablet_background_img: {
    minWidth: 360,
    minHeight: 240,
    maxWidth: 1080,
    maxHeight: 720,
    maxFileSize: 1, //MB
  },
  subgenre_mobile_fair_img: {
    minWidth: 540,
    minHeight: 360,
    maxWidth: 660,
    maxHeight: 440,
    maxFileSize: 1, //MB
  },
  subgenre_tablet_fair_img: {
    minWidth: 540,
    minHeight: 360,
    maxWidth: 660,
    maxHeight: 440,
    maxFileSize: 1, //MB
  },
  menu_img: {
    minWidth: 270,
    minHeight: 180,
    maxWidth: 528,
    maxHeight: 352,
    maxFileSize: 1, //MB
  },
  bar_img: {
    minWidth: 180,
    minHeight: 180,
    maxWidth: 480,
    maxHeight: 320,
    maxFileSize: 1, //MB
  },
  sub_title_menu: {
    minWidth: 270,
    minHeight: 180,
    maxWidth: 528,
    maxHeight: 352,
    maxFileSize: 1, //MB
  },
  eating_way_img: {
    //全画面画像（full_size）
    full_size: {
      minWidth: 1152,
      minHeight: 720,
      maxWidth: 1408,
      maxHeight: 880,
      maxFileSize: 1, //MB
    },
    //幅1/2画像（w1-2_size）
    w1_2_size: {
      minWidth: 576,
      minHeight: 720,
      maxWidth: 704,
      maxHeight: 880,
      maxFileSize: 1, //MB
    },
    //幅2/3画像（w2-3_size）
    w2_3_size: {
      minWidth: 767,
      minHeight: 720,
      maxWidth: 939,
      maxHeight: 880,
      maxFileSize: 1, //MB
    },
    //幅1/3画像（w1-3_size）
    w1_3_size: {
      minWidth: 384,
      minHeight: 720,
      maxWidth: 470,
      maxHeight: 880,
      maxFileSize: 1, //MB
    },
    //幅1/2高さ1/2画像（w1-2_h1-2_size）
    w1_2_h1_2_size: {
      minWidth: 576,
      minHeight: 360,
      maxWidth: 704,
      maxHeight: 440,
      maxFileSize: 1, //MB
    },
    //幅1/3高さ1/2画像（w1-3_h1-2_size）
    w1_3_h1_2_size: {
      minWidth: 384,
      minHeight: 360,
      maxWidth: 470,
      maxHeight: 440,
      maxFileSize: 1, //MB
    },
    //幅1/4高さ1/2画像（w1-4_h1-2_size）
    w1_4_h1_2_size: {
      minWidth: 288,
      minHeight: 360,
      maxWidth: 352,
      maxHeight: 440,
      maxFileSize: 1, //MB
    },
  },
  video_function_video_thumbnail: {
    minWidth: 0,
    minHeight: 0,
    maxWidth: 1920,
    maxHeight: 1080,
    maxFileSize: 2, //MB
  },
  menu_serving_time_image: {
    minWidth: 270,
    minHeight: 180,
    maxWidth: 528,
    maxHeight: 352,
    maxFileSize: 1, //MB
  },
};

export const LANGUAGE_CODES: { [key: string]: string } = {
  JA: 'ja',
  EN: 'en',
  ZH_HANT: 'zh_hant',
  ZH_HANS: 'zh_hans',
  KO: 'ko',
  VI: 'vi',
};

export const LANGUAGES: { [key: string]: string } = {
  [LANGUAGE_CODES.JA]: '日本語',
  [LANGUAGE_CODES.EN]: '英語',
  [LANGUAGE_CODES.ZH_HANT]: '中国語(簡体字)',
  [LANGUAGE_CODES.ZH_HANS]: '中国語(繫体字)',
  [LANGUAGE_CODES.KO]: '韓国語',
  [LANGUAGE_CODES.VI]: 'ベトナム',
};
export const VALID_CSV_FILENAME = ['TMS_MST_MENU.CSV', 'TMS_MST_MENUCONST.CSV', 'TMS_MST_MLU.CSV'];

export const MENU_DISPLAY_TIMING: any = {
  '1': '常時',
  '2': 'ランチオーダー時',
  '3': '定食オーダー時',
  '4': 'ランチ時間帯のみ',
  '5': 'ランチ時間帯以外',
};

export const COUPON_CLASSIFICATION: any = {
  '0': '通常',
  '1': 'クーポン',
  '2': '食べ放題',
};

export const EATING_WAY_BACKGROUND_SETTING = {
  textColor: process.env.REACT_APP_TEXT_COLOR ?? '#ffffff',
  main: {
    genre: {
      //ジャンル
      color1: process.env.REACT_APP_MAIN_GENRE_COLOR1 ?? '#ad5234', //カラー1
      color2: process.env.REACT_APP_MAIN_GENRE_COLOR2 ?? '#8a2c15', //カラー2
    },
    subgenre: {
      //サブジャンル
      color1: process.env.REACT_APP_MAIN_SUBGENRE_COLOR1 ?? '#bfbbb0', //カラー1
      color2: process.env.REACT_APP_MAIN_SUBGENRE_COLOR2 ?? '#9b9993', //カラー2
    },
  },
  other: {
    genre: {
      //ジャンル
      color1: process.env.REACT_APP_OTHER_GENRE_COLOR1 ?? '#ad5234', //カラー1
      color2: process.env.REACT_APP_OTHER_GENRE_COLOR2 ?? '#8a2c15', //カラー2
    },
    subgenre: {
      //サブジャンル
      color1: process.env.REACT_APP_OTHER_SUBGENRE_COLOR1 ?? '#bfbbb0', //カラー1
      color2: process.env.REACT_APP_OTHER_SUBGENRE_COLOR2 ?? '#9b9993', //カラー2
    },
  },
};

export const EATING_WAY_AREA_IMAGE_TYPE = {
  TYPE1: 1,
  TYPE2: 2,
  TYPE3: 3,
  TYPE4: 4,
  TYPE5: 5,
  TYPE6: 6,
  TYPE7: 7,
};

export const EATING_WAY_AREA_IMAGE_TYPE_MAP = {
  [EATING_WAY_AREA_IMAGE_TYPE.TYPE1]: '全画面画像',
  [EATING_WAY_AREA_IMAGE_TYPE.TYPE2]: '幅1/2画像',
  [EATING_WAY_AREA_IMAGE_TYPE.TYPE3]: '幅2/3画像',
  [EATING_WAY_AREA_IMAGE_TYPE.TYPE4]: '幅1/3画像',
  [EATING_WAY_AREA_IMAGE_TYPE.TYPE5]: '幅1/2高さ1/2画像',
  [EATING_WAY_AREA_IMAGE_TYPE.TYPE6]: '幅1/3高さ1/2画像',
  [EATING_WAY_AREA_IMAGE_TYPE.TYPE7]: '幅1/4高さ1/2画像',
};

export const NUM_AREA_TYPE: { [key: string]: number } = {
  TYPE1: 1,
  TYPE2: 2,
  TYPE3: 3,
  TYPE4: 4,
  TYPE5: 5,
  TYPE6: 6,
};

export const PATTERN_TYPE = {
  P1: 'p1',
  P2A: 'p2a',
  P2B: 'p2b',
  P3A: 'p3a',
  P3B: 'p3b',
  P4A: 'p4a',
  P4B: 'p4b',
  P5A: 'p5a',
  P5B: 'p5b',
  P6A: 'p6a',
  P6B: 'p6b',
};

export const DISPLAY_PATTERN: { [key: number]: { [key: string]: string } } = {
  [NUM_AREA_TYPE.TYPE1]: { [PATTERN_TYPE.P1]: PATTERN_TYPE.P1 },
  [NUM_AREA_TYPE.TYPE2]: { [PATTERN_TYPE.P2A]: PATTERN_TYPE.P2A, [PATTERN_TYPE.P2B]: PATTERN_TYPE.P2B },
  [NUM_AREA_TYPE.TYPE3]: { [PATTERN_TYPE.P3A]: PATTERN_TYPE.P3A, [PATTERN_TYPE.P3B]: PATTERN_TYPE.P3B },
  [NUM_AREA_TYPE.TYPE4]: { [PATTERN_TYPE.P4A]: PATTERN_TYPE.P4A, [PATTERN_TYPE.P4B]: PATTERN_TYPE.P4B },
  [NUM_AREA_TYPE.TYPE5]: { [PATTERN_TYPE.P5A]: PATTERN_TYPE.P5A, [PATTERN_TYPE.P5B]: PATTERN_TYPE.P5B },
  [NUM_AREA_TYPE.TYPE6]: { [PATTERN_TYPE.P6A]: PATTERN_TYPE.P6A, [PATTERN_TYPE.P6B]: PATTERN_TYPE.P6B },
};

export const MAXINUM_TOTAL_POS_UNREGISTER = 20;

export const FEATURE_STORE_ID = 3;
export const FEATURE_DELIVERY_ID = 14;
export const FEATURE_IMPORT_DATA_ID = 16;

export const SUFFIX_REARRANGE_MENU = '_A';

// error pattern ids
export const ERROR_PATTERN3_ID = 3;
export const ERROR_PATTERN4_ID = 4;

// target menu source
export const TARGET_MENU_DEFAULT = 0;
export const TARGET_MENU_BAR_GUIDANCE = 1;
export const TARGET_MENU_OVERLAY_FUNCTION = 2;
export const TARGET_MENU_DAILY_MENU = 3;
export const TARGET_MENU_ORDER_QUANTITY_LIMIT = 4;
export const TARGET_MENU_SHABU_SUKIYAKI = 5;
export const TARGET_MENU_DISPLAY_CONTROL_CONDITION = 6;
export const TARGET_MENU_DISPLAY_CONTROL_TIMING = 7;
export const TARGET_MENU_SERVICE = 8;

// screen business type
export const SCREEN_BUSSINESS_TYPE = {
  SHABU_SUKIYAKI: 'しゃぶしゃぶ／すき焼き定食編集',
};

// screen path mapping
export const SCREEN_PATH_MAPPING: { [key: string]: string } = {
  '/business-type/shabu-sukiyaki': SCREEN_BUSSINESS_TYPE.SHABU_SUKIYAKI,
};
